<template>
  <form class="space-y-6" @submit.prevent="onSubmit">
    <div>
      <InputComponent
        label="Prénom "
        type="text"
        v-model="firstName"
        required
        class=""
        placeholder="John"
      />
    </div>
    <div>
      <InputComponent
        label="Nom "
        type="text"
        v-model="lastName"
        required
        class=""
        placeholder="Doe"
      />
    </div>
    <div>
      <InputComponent
        label="Adresse"
        type="text"
        v-model="address"
        required
        class=""
        placeholder="Calavi, Zogbadjè"
      />
    </div>
    <div>
      <InputComponent
        label="Téléphone"
        type="text"
        v-model="phoneNumber"
        required
        class=""
        placeholder="0190909090"
      />
    </div>
    <div>
      <InputComponent
        label="Adresse mail"
        type="email"
        v-model="email"
        required
        class=""
        placeholder="Adresse mail"
      />
    </div>

    <div>
      <InputComponent
        label="Mot de passe"
        data-label="Mot de passe"
        type="password"
        required
        v-model="password"
        class=""
      />
    </div>
    <div class="flex items-start gap-3">
      <input
        id="acceptCgu"
        name="acceptCgu"
        type="checkbox"
        required
        v-model="acceptCgu"
        class="mt-1 w-4 h-4 rounded border-neutral-300 text-primary focus:ring-primary"
      />
      <label for="acceptCgu" class="text-sm text-gray-600 leading-snug">
        J'accepte les
        <button
          type="button"
          class="text-primary underline hover:text-primary-700 font-medium"
          @click="showCguDialog"
        >
          conditions générales d'utilisation
        </button>
      </label>
    </div>

    <button
      :disabled="loading || !acceptCgu"
      :loading="loading"
      type="submit"
      class="buttonComponent w-full"
    >
      M'inscrire
    </button>
    <CguDialog ref="cguDialog" />
  </form>
</template>

<script setup>
import { ref } from 'vue'
import InputComponent from '@/presentation/components/input/InputComponent.vue'
import AuthService from '@/features/auth/authService'
import CguDialog from '@/project/components/auth/CguDialog.vue'
console.error('depecreated component LoginForm is used')

const email = ref('')
const password = ref('')
const firstName = ref('')
const lastName = ref('')
const phoneNumber = ref('')
const address = ref('')
const loading = ref(false)
const acceptCgu = ref(false)
const cguDialog = ref(null)

function showCguDialog() {
  cguDialog.value?.show()
}

function onSubmit() {
  const data = {
    email: email.value,
    password: password.value,
    firstName: firstName.value,
    lastName: lastName.value,
    phoneNumber: phoneNumber.value,
    address: address.value,
  }
  AuthService.signup(data)
}
</script>
